import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete, FormItem } from '@tmapy/style-guide';
import { formatScale, thousandSeparator } from './utils';
import { LocaleContext } from '../../LocaleContext';
export function MapScaleForm(props) {
    const handleChange = (e, eventData) => {
        const value = +eventData.value.replace(/ /g, '');
        props.onChange(value);
    };
    const handleItemClick = (e, eventData) => {
        props.onChange(eventData.item.value);
    };
    const handleKeyDown = (e) => {
        const isNumericKeys = (e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 95 && e.keyCode < 106);
        const isEnabledKeys = [8, 37, 38, 39, 40, 46].indexOf(e.keyCode) !== -1; // remove, delete and arrows
        const isCopyPaste = (e.ctrlKey && e.keyCode === 67) || (e.ctrlKey && e.keyCode === 86);
        !(isNumericKeys || isEnabledKeys || isCopyPaste) && e.preventDefault();
    };
    const renderItem = (item) => {
        return item.label;
    };
    const isInvalid = !(props.mapMinMaxScale?.minScale <= props.value && props.value <= props.mapMinMaxScale?.maxScale);
    let minScale = '';
    let maxScale = '';
    if (props.mapMinMaxScale?.minScale && props.mapMinMaxScale?.maxScale) {
        minScale = formatScale(props.mapMinMaxScale.minScale);
        maxScale = formatScale(props.mapMinMaxScale.maxScale);
    }
    return (_jsx(LocaleContext.Consumer, { children: (context) => {
            const hint = `${context.locale.scaleRange.range} ${minScale} ${context.locale.scaleRange.delimiter} ${maxScale}`;
            return (_jsx(FormItem, { id: 'aria-repex-mapScale', hint: isInvalid ? undefined : hint, errorMessage: isInvalid ? hint : undefined, children: _jsx(Autocomplete, { value: props.value ? thousandSeparator(props.value) : '', renderItem: renderItem, items: props.items, isInvalid: isInvalid, onItemClick: handleItemClick, onChange: handleChange, onKeyDown: handleKeyDown }) }));
        } }));
}
//# sourceMappingURL=form.js.map